import { DataResponseTenant, Tenant, TenantCreateRequest, TenantSearchRequest, TenantUpdateRequest } from "@bluefalcon/users-management-client-fetch";
import { falconClients } from "../clients/falcon.client";

export class TenantsService {

    async searchTenants(request: TenantSearchRequest): Promise<DataResponseTenant> {
        return falconClients.tenants.searchTenants({
            tenantSearchRequest: request,
        });
    }

    async getTenantById(tenantId: string): Promise<Tenant> {
        return falconClients.tenants.getTenantById({
            id: tenantId,
        });
    }

    async createTenant(data: TenantCreateRequest): Promise<Tenant> {
        return falconClients.tenants.createTenant({
            tenantCreateRequest: data,
        });
    }

    async updateTenantById(id: string, data: TenantUpdateRequest): Promise<Tenant> {
        return falconClients.tenants.updateTenantById({
            id,
            tenantUpdateRequest: data,
        });
    }

}
